import React, { useState,useEffect } from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import styled from "styled-components"
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"
import * as FN from "../functions"
import index from "./footer"

var StyledFaChevronRight = styled(FaChevronRight)`
  position: absolute;
  top: 0;
  z-index: 2;
  right: -20px;
  background-color: white;
  height: 100%;
  color: red;
  @media screen and (max-width: 1020px) {
    right: 0px;
  }
`
var StyledFaChevronLeft = styled(FaChevronLeft)`
  position: absolute;
  top: 0;
  z-index: 2;
  left: -20px;
  background-color: white;
  height: 100%;
  color: red;
  @media screen and (max-width: 1020px) {
    left: 0px;
  }
`
var StyledCardDiv = styled.div`
  display: flex;
  /* position:absolute; */
  @media screen and (min-width: 320px) {
    width: 100%;
  }
  @media screen and (min-width: 768px) {
    width: 90%;
  }
  @media screen and (min-width: 1024px) {
    width: 70%;
  }
  @media screen and (min-width: 1440px) {
    width: 60%;
  }
  @media screen and (min-width: 2560px) {
    width: 40%;
  }
`

function SampleNextArrow(props) {
  const { className, style, onClick } = props
  return <StyledFaChevronRight onClick={onClick} />
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props
  return <StyledFaChevronLeft onClick={onClick} />
}

export default function Test(props) {
  const [width, setwidth] = useState(0)
  useEffect(() => {
    FN.DynamicWidth(setwidth, width)
  }, [width])

  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    centerMode: false,
    infinite: false,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 0,
          infinite: false,
          dots: false,
          infinite: false,
          nextArrow: <SampleNextArrow />,
          prevArrow: <SamplePrevArrow />,
          centerMode: false,
        },
      },
      {
        breakpoint: 985,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 0,
          infinite: false,
          dots: false,
          centerMode: false,
          infinite: false,
          nextArrow: <SampleNextArrow />,
          prevArrow: <SamplePrevArrow />,
        },
      },
      {
        breakpoint: 700,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          infinite: false,
          nextArrow: <SampleNextArrow />,
          prevArrow: <SamplePrevArrow />,
        },
      },
    ],
  }

  if (props.data) {
    return props.data.length <= 4 &&
     ( JSON.stringify(width) == "[728,90]" ||
      JSON.stringify(width) == "[970,90]") ? (
      <StyledCardDiv>
        {" "}
        {props.data.map((x, index) => (
          <props.child key={"carousel" + index} {...x} />
        ))}{" "}
      </StyledCardDiv>
    ) : (
      <Slider {...settings}>
        {props.data.map((x, index) => (
          <props.child key={"carouselWrapper" + index} {...x} />
        ))}
      </Slider>
    )
  } else {
    return null
  }
}
